import { render, staticRenderFns } from "./CategoriesProduct.vue?vue&type=template&id=6ca14d73&"
import script from "./CategoriesProduct.vue?vue&type=script&lang=js&"
export * from "./CategoriesProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports